import { React, useState } from 'react';
import './accordion.scss';

// Icons
// ---------------------
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron_left_black_24dp.svg';

export const Accordion = ({
  text,
  aria,
  maxHeight,
  initialExpand = false,
  ...props
}) => {
  const [expanded, setExpanded] = useState(initialExpand);
  const [isAnimating, setIsAnimating] = useState(false);

  const toggleAccordion = (e) => {
    setExpanded(!expanded);
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
    }, 500); // Delay length = accordion transition length
  };

  return (
    <div
      className={`accordion-component${expanded ? ' expanded' : ''}${
        isAnimating ? ' animating' : ''
      }`}
      data-testid="accordion"
    >
      <div className="accordion-wrapper">
        <button
          className="stripped-button accordion-clickbox"
          aria-label={aria ? aria : `Expand ${text}`}
          aria-expanded={expanded}
          onClick={(e) => toggleAccordion(e)}
        >
          <span>{text}</span>
          <ChevronIcon />
        </button>
      </div>
      <div className="accordion-content" data-testid="accordion-content">
        {expanded || isAnimating ? props.children : ''}
        {/* {props.children} */}
      </div>
    </div>
  );
};

Accordion.propTypes = {};
